<template>
    <v-card>
        <v-card-title>Quality check
            <v-spacer></v-spacer><v-btn class="primary ma-2" :disabled="!quality_data.update_enabled" x-small v-on:click="saveUserAndDate()">save</v-btn>
        </v-card-title>
        <v-card-text>
            <p :class="{'default-ptr': true}">The data of this accommodation has been checked on correctness and completeness</p>
            <v-row cols="12" no-gutter dense>
                <v-col cols="1" v-if="quality_data.update_enabled">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-avatar  v-on="on" 
                                       v-bind="attrs" 
                                       size="20" 
                                       color="primary" 
                                       class="avatar-ptr ml-1 mt-1" 
                                       v-on:click="setUserAndDate()">
                                <v-icon small color="white">mdi-chevron-double-right</v-icon>
                            </v-avatar>
                        </template>
                        <span>Quick entry: current user and today</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="6">
                    <v-select v-model="selected_gebr" 
                              v-bind:items="gebr" 
                              item-value="code" 
                              item-text="name" 
                              label="Checked by" 
                              :disabled="!quality_data.update_enabled"
                              dense 
                              clearable
                              class="pl-1 mr-6">
                    </v-select>
                </v-col>
                <v-col cols="3">
                    <v-menu
                        v-model="menuCheckDate"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        readonly 
                        dense
                        offset-y
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field                      
                                v-model="checkDateDMY"
                                label="Check date"
                                v-bind="attrs"
                                v-on="on"
                                dense
                                :disabled="!quality_data.update_enabled"
                                clearable
                                :readonly=false 
                                class="pr-3">
                            </v-text-field>
                        </template>          
                        <v-date-picker v-model="quality_data.quality_checked_date" 
                                       v-bind:first-day-of-week="1"  
                                       v-on:input="checkDateDMY = $moment(quality_data.quality_checked_date).format('DD-MM-YYYY'); 
                                       menuCheckDate = false">
                        </v-date-picker>
                    </v-menu>                                        
                </v-col>
            </v-row>
        </v-card-text>        
    </v-card>
</template>

<script>

    import mxgetuser from '@/mixins/getuser';
    import moment from 'moment';
    

    export default{

        props: {
            quality_data: Object,
        },

        mixins:[mxgetuser],  
        data () {
            return {
                selected_gebr: '',
                menuCheckDate:false,
                checkDateDMY:'',
            }
        },
        mounted (){
            this.selected_gebr = this.quality_data.user;
            if(this.quality_data.date != '' && this.quality_data.date != null) {
                this.checkDateDMY = moment(this.quality_data.date).format('DD-MM-YYYY');
            } else {
                this.checkDateDMY = null;
            }           
           this.getGebr();
        },
        methods: {
            setUserAndDate(){
                this.selected_gebr = this.quality_data.current_user;
                this.checkDateDMY = moment(new Date()).format('DD-MM-YYYY');
            },
            saveUserAndDate(){                
                this.$axios.post("ares/json/ares/huis/updQualityCheckData.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updQualityCheckData"
                    },
                    updQualityCheckData: {
                        huis_encrid: this.quality_data.huis_encrid,
                        checkDate: this.checkDateDMY,
                        checkUser: this.selected_gebr,
                    }
                    }).then(res => {
                        if (res.data.error) {                            
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: res.data.error.message,
                                color: "error"
                            })            
                        }  else {
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: res.data.updQualityCheckData.text,
                                color: res.data.updQualityCheckData.color
                            });
                        }
                    })          
            },
         
        }

    }
</script>

<style scoped>
  .avatar-ptr {
    cursor: pointer;
  }  
  .default-ptr {
    cursor: default !important;
  }    
</style>